import React from 'react';
import DashboardBox from '../../components/DashboardBox';
import { useTheme } from "@mui/material";
import BoxHeader from '../../components/BoxHeader';
import {
  ResponsiveContainer,
  CartesianGrid,
  AreaChart,
  BarChart,
  Bar,
  LineChart,
  XAxis,
  YAxis,
  Legend,
  Line,
  Tooltip,
  Area,
} from "recharts";




const Row1 = (props) => {
  const { palette } = useTheme();
  const revenue_data = props.revenue_expenses_data.revenue_expenses_data
  const profit_data = props.revenue_expenses_data.revenue_profit_data
  const revenue = props.revenue_expenses_data.revenue
  console.log(revenue)


  const calculateFirstToLastMonthDifference = (data) => {
    if (!data || data.length < 2) return "0%";

    const firstMonthRevenue = data[0].revenue;
    const lastMonthRevenue = data[data.length - 1].revenue;

    const difference = lastMonthRevenue - firstMonthRevenue;
    const percentageDifference = (difference / firstMonthRevenue) * 100;

    return `${percentageDifference.toFixed(2)}%`;
  };



  return (
    <>
      <DashboardBox gridArea="a">
        <BoxHeader
          title="Revenue and Expenses"
          subtitle="top line represents revenue, bottom line represents expenses"
          sideText={calculateFirstToLastMonthDifference(revenue_data)}
        />
        <ResponsiveContainer width="100%" height="100%">
          <AreaChart
            width={500}
            height={400}
            data={revenue_data}
            margin={{
              top: 15,
              right: 25,
              left: -10,
              bottom: 80,
            }}
          >
            <defs>
              <linearGradient id="colorRevenue" x1="0" y1="0" x2="0" y2="1">
                <stop
                  offset="5%"
                  stopColor={palette.red[900]}
                  stopOpacity={0.5}
                />
                <stop
                  offset="95%"
                  stopColor={palette.red[900]}
                  stopOpacity={0}
                />
              </linearGradient>
              <linearGradient id="colorExpenses" x1="0" y1="0" x2="0" y2="1">
                <stop
                  offset="5%"
                  stopColor={palette.blue[900]}
                  stopOpacity={0.5}
                />
                <stop
                  offset="95%"
                  stopColor={palette.blue[900]}
                  stopOpacity={0}
                />
              </linearGradient>
            </defs>
            <XAxis
              dataKey="name"
              tickLine={false}
              style={{ fontSize: "10px", fill: "white" }}
            />
            <YAxis
              tickLine={false}
              axisLine={{ strokeWidth: "0" }}
              style={{ fontSize: "10px", fill: "white" }}
              domain={['auto', 'auto']}

            />
            <Tooltip
              contentStyle={{ background: 'black' }}
            />

            <Area
              type="monotone"
              dataKey="revenue"
              dot={true}
              stroke={palette.white[100]}
              fillOpacity={1}
              fill="url(#colorRevenue)"
            />
            <Area
              type="monotone"
              dataKey="expenses"
              dot={true}
              stroke={palette.white[100]}
              fillOpacity={1}
              fill="url(#colorExpenses)"

            />
          </AreaChart>
        </ResponsiveContainer>
      </DashboardBox>
      <DashboardBox gridArea="b">
        <BoxHeader
          title="Profit and Revenue"
          subtitle="top line represents revenue, bottom line represents expenses"
          sideText="+4%"
        />
        <ResponsiveContainer width="100%" height="100%">
          <LineChart
            width={500}
            height={400}
            data={profit_data}
            margin={{
              top: 20,
              right: 0,
              left: -10,
              bottom: 55,
            }}
          >
            <CartesianGrid vertical={false} stroke={palette.white[800]} />
            <XAxis
              dataKey="name"
              tickLine={false}
              style={{ fontSize: "10px", fill: "white" }}
            />
            
            <YAxis
              yAxisId="left"
              tickLine={false}
              axisLine={false}
              style={{ fontSize: "10px",fill: "white" }}
            />
            <YAxis
              yAxisId="right"
              orientation="right"
              tickLine={false}
              axisLine={false}
              style={{ fontSize: "10px",fill: "white" }}
            />
            <Tooltip
              contentStyle={{ background: 'black' }}
            />
            <Legend
              height={20}
              wrapperStyle={{
                margin: "0 0 50px 0",
              }}
            />
            <Line
              yAxisId="left"
              type="monotone"
              dataKey="profit"
              stroke={palette.green[500]}
            />
            <Line
              yAxisId="right"
              type="monotone"
              dataKey="revenue"
              stroke={palette.red[500]}
            />
          </LineChart>
        </ResponsiveContainer>
      </DashboardBox>
      <DashboardBox gridArea="c">
      <BoxHeader
          title="Revenue Month by Month"
          subtitle="graph representing the revenue month by month"
          sideText="+4%"
        />
        <ResponsiveContainer width="100%" height="100%">
          <BarChart
            width={500}
            height={300}
            data={revenue}
            margin={{
              top: 17,
              right: 15,
              left: -5,
              bottom: 58,
            }}
          >
            <defs>
              <linearGradient id="colorRevenue" x1="0" y1="0" x2="0" y2="1">
                <stop
                  offset="5%"
                  stopColor={palette.primary[300]}
                  stopOpacity={0.8}
                />
                <stop
                  offset="95%"
                  stopColor={palette.primary[300]}
                  stopOpacity={0}
                />
              </linearGradient>
            </defs>
            <CartesianGrid vertical={false} stroke={palette.white[800]} />
            <XAxis
              dataKey="name"
              axisLine={false}
              tickLine={false}
              style={{ fontSize: "10px",fill: "white" }}
            />
            <YAxis
              axisLine={false}
              tickLine={false}
              style={{ fontSize: "10px",fill: "white" }}
            />
            <Tooltip contentStyle={{ background: 'black' }}/>
            <Bar dataKey="revenue" fill="url(#colorRevenue)" />
          </BarChart>
        </ResponsiveContainer>
      </DashboardBox>
    </>
  )
}

export default Row1